import {stage} from '../stage';

// The AppSync APIs this app calls besides its default one (users-api, in
// ./index.ts). Endpoints live in config/amplify, never in a feature
// (checklist §10a).

// flexinet-console-api — the OWNER of the Account entity.
//
// ⚠️ This app's own API (flexinet-users-api) has no Account type. The
// signed-in operator's account record lives in console-api and nowhere
// else, so reading it means a second GraphQL client pointed here. See
// `docs/API_ENTITY_SEAM_MAP.md` §2: `Account.id` is console-api's, minted
// at insert, and it is NOT the Cognito `sub`.
//
// ⚠️ Every endpoint below was read live from its own account on 2026-09-20
// with `aws appsync list-graphql-apis`, never reconstructed from an apiId.
// The endpoint host is not derivable from the API id.
const consoleApi = {
    prod: {
        endpoint: 'https://f3lssqzzmbd6vfegfduj5ebmye.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    test: {
        endpoint: 'https://x2tksew75nbnja3x7yuvmlv6pe.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    dev: {
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
    ide: {
        endpoint: 'https://bbaseq6utvbztehupw2byq3eme.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
    },
};

export const consoleApiConfig = consoleApi[stage] ?? consoleApi.dev;
